import { DotProps } from 'recharts';
import { GraphPoint } from '@hud/portal-dtos/webapp-common.dto';
import React from 'react';

interface ConditionalDotProps extends DotProps {
  dataKey: string;
  index: number;
}

function isSingularPoint(data: GraphPoint[], index: number, dataKey: keyof GraphPoint) {
  const leftPoint = data[index - 1];
  const rightPoint = data[index + 1];

  // if left-most point, then check if right is empty
  // if right-most point, then check if left is empty
  // if non-edge point, then check both left and right
  return data[index][dataKey] !== null &&
      ((index === 0 && rightPoint?.[dataKey] === null) ||
      (index === data.length - 1 && leftPoint?.[dataKey] === null) ||
      (index > 0 && index < data.length - 1 && leftPoint?.[dataKey] === null && rightPoint?.[dataKey] === null))
}

// see https://github.com/recharts/recharts/issues/5218
export function getSingularDot(data: GraphPoint[]) {

  // shows a dot conditionally if it's a single data points with no neighbors
  return function SingularDot(props: ConditionalDotProps)  {
    const { cx, cy, fillOpacity, height, stroke, width } = props;
    const svgProps = {
      cx,
      cy,
      fill: stroke, // take style params from those intended for "line"
      fillOpacity,
      height,
      r: 2,
      stroke,
      width,
    };
    const { index } = props;

    const dataKey = props.dataKey as keyof GraphPoint;

    if (isSingularPoint(data, index, dataKey)) {
      return <circle
        key={props.key + dataKey}
        {...svgProps}
        className="recharts-dot recharts-area-dot"
      ></circle>
    } else {
      return null;
    }
  }
}

// disable animation in case graph contains only singular points
// otherwise, dots appear too late
export function shouldShowAnimation(data: GraphPoint[], dataKey: string) : boolean {
  const typedDataKey = dataKey as keyof GraphPoint; // thanks typescript

  //check if there's a singular non-singular point
  return !data.some((point, index) => isSingularPoint(data, index, typedDataKey));
}
